export function normalizePhoneNumber(number: string): string {
  return number
    .replace(/\s+/gi, '')
    .replace(/[-()[\]]+/gi, '')
    .trim();
}
